import React from 'react';

interface CheckCircleIconProps {
  className?: string;
  size?: number;
}

export const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({ className = '', size = 12 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_2834_5126)">
        <path
          d="M4.76025 0.510284C5.86947 0.259672 7.0268 0.351787 8.08008 0.771026L8.28955 0.858917L8.34619 0.888213C8.62105 1.04565 8.73753 1.38853 8.60596 1.68411C8.47425 1.97969 8.14123 2.12297 7.84033 2.02396L7.78076 2.00101L7.61768 1.93216C6.79852 1.60616 5.89829 1.53462 5.03564 1.72952C4.11546 1.93746 3.28725 2.43768 2.67432 3.15481C2.06145 3.87192 1.69639 4.76775 1.63428 5.70901C1.5722 6.6504 1.8161 7.587 2.32959 8.37845C2.84308 9.1699 3.59892 9.77415 4.48389 10.1011C5.36878 10.428 6.3356 10.4598 7.24023 10.1924C8.1449 9.92493 8.93903 9.37229 9.50391 8.61673C10.0687 7.86121 10.3744 6.94331 10.375 6.00003V5.54007C10.375 5.19489 10.6548 4.91507 11 4.91507C11.3452 4.91507 11.625 5.19489 11.625 5.54007V6.00052C11.6243 7.21344 11.2316 8.3938 10.5054 9.36526C9.77909 10.3368 8.75791 11.0472 7.59473 11.3911C6.43159 11.735 5.18853 11.6938 4.05078 11.2735C2.91296 10.8531 1.94145 10.0762 1.28125 9.05862C0.621046 8.04104 0.307396 6.83734 0.387206 5.62698C0.46702 4.41663 0.93602 3.26439 1.72412 2.34231C2.5122 1.42031 3.57716 0.777604 4.76025 0.510284ZM10.5581 1.55814C10.8022 1.31406 11.1978 1.31406 11.4419 1.55814C11.6859 1.80222 11.686 2.19787 11.4419 2.44192L6.44189 7.44192C6.19783 7.68592 5.80217 7.68592 5.5581 7.44192L4.0581 5.94192L4.01514 5.89456C3.81485 5.6491 3.82931 5.28699 4.0581 5.05814C4.28695 4.82929 4.64905 4.81487 4.89453 5.01517L4.94189 5.05814L6 6.11624L10.5581 1.55814Z"
          fill="#008158"
        />
      </g>
      <defs>
        <clipPath id="clip0_2834_5126">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
